import type { CustomIconProps } from '../types';

const Chat = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '17'}
        height={height ?? '16'}
        viewBox="0 0 17 16"
        fill="none"
    >
        <path d="M0 0V12L2 10H13V0H0Z" fill="#414042" />
        <path d="M17 4H15V12H4V14.5H15L17 16V4Z" fill="#414042" />
    </svg>
);

export default Chat;
